import React, { useEffect, useState } from 'react'
import InputField from '../../../feature-module/components/Input'
import { useForm } from 'react-hook-form'
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import SalePersonServices from '../../../services/SalePerson'
import { modalCloseListener } from '../../../utils/helper'

const SalePersonModal = ({ updateData, resetUpdateData, getData }) => {

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const submitForm = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        name: formData?.name,
        commission: formData?.commission,
        remarks: formData?.remarks,
        is_active: formData?.status
      }
      if (updateData?.id) {
        // *Update 
        await SalePersonServices.updateSalePerson(updateData?.id, obj)
        SuccessToaster('Update Successfully')
      } else {
        // *Create 
        await SalePersonServices.createSalePerson(obj)
        SuccessToaster('Create Successfully')
      }
      reset();
      const btn = document.getElementById('modalClose')
      btn.click();
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateData) {
      setValue('name', updateData?.name)
      setValue('commission', updateData?.commission)
      setValue('remarks', updateData?.remarks)
      setValue('status', updateData?.is_active)
    }
  }, [updateData]);

  useEffect(() => {
    const cleanup = modalCloseListener("open-modal", () => {
      reset();
      resetUpdateData();
    });

    return cleanup;
  }, []);

  return (
    <div className="modal fade" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{updateData?.id ? "Update Supplier" : "Create Store"}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form onSubmit={handleSubmit(submitForm)}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Name"
                          type="text"
                          error={errors?.name?.message}
                          register={register("name", {
                            required: 'Please enter sale person name.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Commission"
                          type="number"
                          error={errors?.commission?.message}
                          register={register("commission", {
                            required: 'Please enter commission.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-blocks">
                        <InputField
                          label="Remarks"
                          inputType="textarea"
                          placeholder="Type Remarks"
                          register={register("remarks")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <InputField
                          id="checkbox1"
                          type="checkbox"
                          className="check"
                          defaultChecked={true}
                          register={register("status")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      id="modalClose"
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalePersonModal;
